import React from "react";
import { getColorClasses } from "../../utils/getBackgroundColor";
import { EditorialBlock as EditorialBlockType } from "../../types/optimizely/blocks";
import classNames from "classnames";
import dompurify from "dompurify";
import { renderToString } from "react-dom/server";
import ArrowRight from "../../assets/arrow-right.svg?react";
import logo from "../../assets/wilhelmsen_logo_flag.svg";
import { isHeaderTag } from "../../utils/isHeaderTag";
import { getHeaderClasses } from "../../utils/getHeaderClasses";

interface EditorialBlockProps extends EditorialBlockType {}

const getAnchorClasses = (backgroundColor: string) =>
  `w-1/2 bg-transparent ${backgroundColor} hover:${backgroundColor} items-center font-bold rounded flex`;
const localPurifier = dompurify();

const EditorialBlock = ({
  text,
  backgroundColor: optiBgColor,
}: EditorialBlockProps) => {
  const backgroundColor = getColorClasses(optiBgColor?.value);

  localPurifier.addHook("beforeSanitizeAttributes", (node) => {
    if (node.nodeName && node.nodeName === "A") {
      const hasSvgChild =
        Array.from(node.childNodes).filter((child) => child.nodeName === "SPAN")
          .length > 0;
      node.setAttribute(
        "class",
        `${getAnchorClasses(
          backgroundColor
        )} font-normal group hover:text-primaryBlue`
      );

      if (!hasSvgChild) {
        const icon = renderToString(
          <span className="ml-2 group-hover:translate-x-2 transition-all ease-out">
            <ArrowRight />
          </span>
        );
        node.innerHTML += icon;
      }
    }

    if (isHeaderTag(node)) {
      const level = parseInt(node.nodeName.charAt(1));
      node.setAttribute("class", getHeaderClasses(level));
    }
  });

  return (
    <div
      className={classNames(
        "p-6 lg:p-8 flex flex-col whitespace-pre-wrap",
        backgroundColor
      )}
    >
      <div
        className="text-gray-600 md:text-md w-full"
        dangerouslySetInnerHTML={{
          __html: localPurifier.sanitize(text.value),
        }}
      />
    </div>
  );
};

export default EditorialBlock;
